import { server_ip } from "../config";

export async function fetchPosts(filter, options) {
    try {
        const response = await fetch(`${server_ip}/api/posts/fetch`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                filter,
                options
            })
        })
        return await response.json();
    } catch (error) {
        return { errno: 1, message: 'Unexpected error' }
    }
}
export async function adminInsertOne(token, userId, content, photos) {
    try {
        const response = await fetch(`${server_ip}/api/posts/admin/newPost`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                userId,
                content,
                ...photos? { photos } : {}
            })
        })
        return await response.json();
    } catch (error) {
        return { errno: 1, message: 'Unexpected error' }
    }
}

export async function deletePostById(token, postId) {
    try {
        const response = await fetch(`${server_ip}/api/posts/${postId}`, {
            method: 'DELETE',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        })
        return await response.json();
    } catch (error) {
        return { errno: 1, message: 'Unexpected error' }
    }
}